<template>
    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
        <div class="mb-10 font-weight-bold text-dark">
            Geschäft erstellen oder auswählen
        </div>
        <AssociateStore v-model="formData.store"
                        @store_role="(role) => formData.role = role"
        />
    </div>
</template>

<script>
import AssociateStore from "@components/Invitation/AssociateStore.vue";

export default {
    components: {AssociateStore},

    props: {
        old: Object
    },

    data() {
        return {
            formData: {
                role: null,
                store: null
            }
        }
    },

    watch: {
        formData: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
